/**
 * 是否为函数
 * @param  {*} fn 对象
 * @return {Boolean}  是否函数
 */
var isType = require('./is-type');

var isFunction = function isFunction(value) {
  return isType(value, 'Function');
};

module.exports = isFunction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/type/is-function.js
// module id = 5
// module chunks = 0